import { useState } from 'react'
import CorsiUtentiService from '../services/CorsiUtentiService/CorsiUtentiService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useCorsiUtenti = () => {
    const [loadingState, setLoadingState] = useState({
        isLoadingCorsiUtentiCreating: false,
        isLoadingCorsiUtenteDeleting: false,
        isLoadingCorsiUtenteUpdate: false,
        isLoadingCorsiUtenteByUserId: false,
        isLoadingCorsoUtentiByIdCorso: false,
      });

    const [modalState, setModalState] = useState({
      assignCourseToUser: false,
      deleteCorsiUtenteModal: false,
      updateCorsiUtenteModal: false,
      updateSpedizioneModal: false,
    });


      const assignCourseToUser = async (data, isNotCreateUserPhase, isGestioneCorsiUtenti) => {
        setLoadingState({ ...loadingState, isLoadingCorsiUtentiCreating: true });
        try {
          let response = await CorsiUtentiService.assignCourseToUser(data);
          if(response) {
            if(isNotCreateUserPhase) {
                alertService.success(`Corso ${data?.denominazione} assegnato con successo`, {autoClose: true});
            } 
            if(isGestioneCorsiUtenti){
              alertService.success(`${data?.nome} ${data?.cognome} assegnato con successo`, {autoClose: true});
            }
            return response;
         }
        } catch (err) {
            handleError(err, {
              RESOURCE_ALREADY_EXISTS: `${data?.nome} ${data?.cognome} è già iscritto al corso`
            })
        } finally {
            setLoadingState({ ...loadingState, isLoadingCorsiUtentiCreating: false });
        }
      };

      const getCorsiUtenteByToken = async (data) => {
        setLoadingState({ ...loadingState, isLoadingCorsiUtenteByUserId: true });
        try {
          let response = await CorsiUtentiService.getCorsiUtenteByToken(data);
          return response;
        } catch (err) {
          handleError(err)
        } finally {
            setLoadingState({ ...loadingState, isLoadingCorsiUtenteByUserId: false });
        }
      };


      const getCorsoUtentiByIdCorso = async (data) => {
        setLoadingState({ ...loadingState, isLoadingCorsoUtentiByIdCorso: true });
        try {
          let response = await CorsiUtentiService.getCorsoUtentiByIdCorso(data);
          return response;
        } catch (err) {
          handleError(err)
        } finally {
          setLoadingState({ ...loadingState, isLoadingCorsoUtentiByIdCorso: false });
        }
      };

      const deleteCorsiUtenti = async (data) => {
        setLoadingState({ ...loadingState, isLoadingCorsiUtenteDeleting: true });
        try {
          let response = await CorsiUtentiService.deleteCorsoUtenti(data);
          const res = await response.json();
          if(data?.nome && data?.cognome) {
            alertService.success(`${data?.nome} ${data?.cognome} rimosso con successo`, {autoClose: true});
          } else {
            alertService.success(`Utente rimosso con successo`, {autoClose: true});
          }
          return res;
        } catch (error) {
          handleError(error);
        } finally {
          setLoadingState({ ...loadingState, isLoadingCorsiUtenteDeleting: false });
        }
      }

      const updateCorsiUtenti = async (data) => {
        setLoadingState({ ...loadingState, isLoadingCorsiUtenteUpdate: true });
        try {
          let response = await CorsiUtentiService.updateCorsoUtenti(data);
          alertService.success(`Utente aggiornato con successo`, {autoClose: true});
          return response;
        } catch (error) {
          handleError(error);
        } finally {
          setLoadingState({ ...loadingState, isLoadingCorsiUtenteUpdate: false });
        }
      }

  return {
    loadingStateCorsiUtenti: loadingState,
    modalStateCorsiUtenti: modalState,
    setModalStateCorsiUtenti: setModalState,
    deleteCorsiUtenti,
    assignCourseToUser,
    getCorsoUtentiByIdCorso,
    getCorsiUtenteByToken,
    updateCorsiUtenti,
  };      
}

export default useCorsiUtenti;